import React, { Component } from "react";
import { baseUrl } from "../../../../../utils";
import { LIVE_API } from "../../../../../actions/api";

const shareOptions = ["facebook", "twiiterX", "instagram", "envelope", "copy"];
const shrContent = `Hi,\nHere's what's trending in the event. Feel free to engage and share with others.\n\n`;
class ShareUrls extends Component{
    content = null;
    state={
        showTt: false,
        copyData:false
    }
   
    componentDidMount(){
        this.content = document.querySelector('.share-text div strong');
    }
    
    //share function to share content
    shareContent = (type,ShareUrl) =>{
        let msg = this.content ? `${shrContent}${this.content.innerText}` : null;

        const { shareLink } = this.props;
        let url = null;
        if(type == 'facebook'){
            url = `https://www.facebook.com/sharer.php?u=${ShareUrl} `;
        }else if(type == 'twiiterX'){
            url = `http://x.com/share?url=${ShareUrl}`;
        }else if(type == 'instagram'){
            url = 'https://www.instagram.com/direct/inbox/';
        }else if(type == 'envelope'){
            url = `mailto:?subject=Share%20Interactive%20widget%20url&body=${msg}`;
        }else{
            this.setState({ showTt: true }, () => setTimeout(() => this.setState({ showTt: false }), 1000));
        }
        if(msg) navigator.clipboard.writeText(msg);
        if(url) window.open(url, "_blank");
    }

    copyUrl = () => {
        navigator.clipboard.writeText(this.content ? this.content.innerText : null);
        this.setState({copyData: true}, () => setTimeout(() => this.setState({ copyData: false }), 1000))
    }

    render(){
        const { showTt, copyData } = this.state;
        const ShareUrl = `${LIVE_API ? 'https://live.socialwalls.com/' : 'https://display-test.socialwalls.com/'}${this.props.wallUrl}`
        
        return(
            <div className="shareUrls-section h-100">
                <div className="form-group mb-5">
                    <h4 className="mb-6 font-weight-boldest">Share Your Social Wall With Your Event Attendees:</h4>
                </div>
                <div className="form-group mb-5">
                    <h5 className="mb-5">Step 1: Customize message for your audience or use the template below. </h5>
                </div>
                <div className="share-text form-group mb-lg-10 mb-6">
                    <div className="position-relative">
                        <p className="mb-1">Hi,</p>
                        <p className="pb-4 mb-4">Here's what's trending in the event. Feel free to engage and share with others. Show some love by reacting to the content.</p>
                        <strong onClick={this.copyUrl}>{ShareUrl}</strong>
                        {copyData ? <span className="share-copy-text position-absolute end-0 me-3">Link Copied</span> : null}
                    </div>
                </div>
                <div className="share-icons">
                    <h5 className="mb-5">Step 2: Share the message with your audience encouraging them to engage. </h5>
                    <ul className="d-flex flex-wrap align-items-center cursor-pointer">
                        {shareOptions.map(option => 
                        <li onClick={() => this.shareContent(option,ShareUrl)} key={option}>
                            <img src={baseUrl(`social-icons/${option}.svg`)} />
                        </li>)}
                        {showTt ? <span className="share-copy-text">Copied to clipboard</span> : null}
                    </ul>
                </div>
            </div>
        )
    }
}
export default ShareUrls;